import React from "react";
import HeroSection from "@/components/home/HeroSection";
import EventInfoCard from "@/components/home/EventInfoCard";
import SuperintendentVideo from "@/components/home/SuperintendentVideo";
import GradeBandButtons from "@/components/home/GradeBandButtons";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <EventInfoCard />
      <SuperintendentVideo />
      <GradeBandButtons />
    </div>
  );
}
